import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import PlanForm from "../../../components/forms/plan-form";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import { derivers } from 'react-pivottable/Utilities'
import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyComponent from 'react-plotly.js/factory';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import tableToExcel from "@linways/table-to-excel";
import { Button } from "../../../components/button";
import { analyticTypes } from "../analytic-types";
import { setAdvancedEditing } from "../../../slices/analytics";
import { SvgAnalytics, SvgExport } from "../../../components/svg";
import { Toggler } from "../../../components/toggler";
import { useWindowSize } from "@uidotdev/usehooks";


const translations = [
    gettext('Toggle editing off'),
    gettext('Toggle editing on'),
    gettext('Export to excel'),
]


const AnalyticsDetail = () => {

    const dispatch = useDispatch()
    const transactions = useSelector((state) => state.transactions)
    const advancedEditing = useSelector((state) => state.analytics.advancedEditing)
    const Plot = createPlotlyComponent(window.Plotly);
    const PlotlyRenderers = createPlotlyRenderers(Plot);
    const renderers = Object.assign({}, TableRenderers, PlotlyRenderers)
    const { analyticId } = useParams();
    const size = useWindowSize();


    const selectedAnalytic = analyticTypes.find((analyticType) => {
        return analyticType.slug === analyticId
    })

    const [currentProps, setCurrentProps] = useState(selectedAnalytic)

    let data = []
    if (!transactions.loading) {
        data = JSON.parse(JSON.stringify(transactions.results));
        console.log(data)
    }

    useEffect(() => {
        console.log("trigger")
        if (selectedAnalytic.plotlyOptions) {
            const selectedAnalyticModified = selectedAnalytic
            if (advancedEditing) {
                selectedAnalyticModified.plotlyOptions.width = document.querySelector(".analytics-detail").offsetWidth - 267;
            } else {
                selectedAnalyticModified.plotlyOptions.width = document.querySelector(".analytics-detail").offsetWidth;
            }
            setCurrentProps(selectedAnalyticModified)
        } else {
            setCurrentProps(selectedAnalytic)
        }
    }, [selectedAnalytic, size, advancedEditing])



    const handleExportClick = () => {
        var htmlTable = document.querySelector(".pvtTable").cloneNode(true);

        const htmlTableHead = htmlTable.querySelector("thead");
        const htmlHeadRows = htmlTableHead.querySelectorAll("tr");
        htmlHeadRows.forEach((headRow) => {
            const htmlHeadCells = headRow.querySelectorAll("th");
            htmlHeadCells.forEach((htmlCell) => {
                const isAxisLabel = htmlCell.classList.contains("pvtAxisLabel");
                const isColLabel = htmlCell.classList.contains("pvtColLabel");
                const isTotalLabel = htmlCell.classList.contains("pvtTotalLabel");

                if (isAxisLabel) {
                    htmlCell.setAttribute("data-a-h", "left");
                    htmlCell.setAttribute("data-a-v", "middle");
                }
                if (isColLabel) {
                    htmlCell.setAttribute("data-a-h", "center");
                    htmlCell.setAttribute("data-a-v", "middle");
                }
                if (isTotalLabel) {
                    htmlCell.setAttribute("data-exclude", "true");
                }
            });
        });

        const htmlTableBody = htmlTable.querySelector("tbody");
        const htmlBodyRows = htmlTableBody.querySelectorAll("tr");
        htmlBodyRows.forEach((bodyRow) => {
            const htmlBodyCells = bodyRow.querySelectorAll("th, td");
            htmlBodyCells.forEach((htmlCell) => {
                const isRowLabel = htmlCell.classList.contains("pvtRowLabel");
                const isValue = htmlCell.classList.contains("pvtVal");
                const isTotal = htmlCell.classList.contains("pvtTotal");
                const isTotalLabel = htmlCell.classList.contains("pvtTotalLabel");
                const isGrandTotal = htmlCell.classList.contains("pvtGrandTotal");

                if (isRowLabel) {
                    htmlCell.setAttribute("data-a-h", "left");
                    htmlCell.setAttribute("data-a-v", "middle");
                }
                if (isValue) {
                    htmlCell.setAttribute("data-a-h", "right");
                    htmlCell.setAttribute("data-a-v", "middle");
                    htmlCell.setAttribute("data-t", "n");
                }
                if (isTotal || isTotalLabel || isGrandTotal) {
                    htmlCell.setAttribute("data-exclude", "true");
                }
            });
        });

        htmlTable.innerHTML = htmlTable.innerHTML.replace(/,/g, "");

        tableToExcel.convert(htmlTable, { name: "export.xlsx" });
    };

    return (
        <div className={`analytics-detail position-relative ${advancedEditing ? '' : 'simple'}`}>
            <div className="d-flex advanced-editing justify-content-end w-100">
                <Toggler name={'advanced-editing'} isActive={advancedEditing} onClick={() => dispatch(setAdvancedEditing(!advancedEditing))} />
                {advancedEditing ?
                    <>{gettext('Toggle editing off')}</>
                    :
                    <>{gettext('Toggle editing on')}</>
                }
            </div>
            <div class="d-flex align-items-center">
                <h1 className="title me-auto mb-5">{selectedAnalytic && selectedAnalytic.name}</h1>
                {selectedAnalytic && selectedAnalytic.rendererName && selectedAnalytic.rendererName.includes("Table") &&
                    <div className="mb-5 nowrap">
                        <Button icon={<SvgExport />} variant='secondary' onClick={handleExportClick}>{gettext('Export to excel')}</Button>
                    </div>
                }
            </div>
            {!transactions.loading &&
                <PivotTableUI
                    data={data}
                    onChange={setCurrentProps}
                    {...currentProps}
                    renderers={renderers}
                    hiddenAttributes={["created_at"]}
                    derivedAttributes={{
                        year: derivers.dateFormat("created_at", "%y"),
                        month: derivers.dateFormat("created_at", "%m"),
                        day: derivers.dateFormat("created_at", "%d"),
                        "day of week": derivers.dateFormat("created_at", "%x"),
                    }}
                />
            }
        </div>
    )

}

export default AnalyticsDetail